export const STATUS_TOKENS = {
  fallEvents: {
    FALL_RECORDED: { label: 'Fall recorded', color: 'warning' },
    CLIENT_LABELED: { label: 'Client labeled', color: 'info' },
    ADMIN_REVIEWED: { label: 'Admin reviewed', color: 'info' },
    ESCALATED: { label: 'Escalated', color: 'error' },
    CLOSED: { label: 'Closed', color: 'success' },
  },
  monitoring: {
    READY: { label: 'Ready', color: 'info' },
    RUNNING: { label: 'Live', color: 'success' },
    STOPPED: { label: 'Stopped', color: 'default' },
    ERROR: { label: 'Issue', color: 'error' },
  },
  default: {
    ACTIVE: { label: 'Active', color: 'success' },
    INACTIVE: { label: 'Inactive', color: 'default' },
  },
};

export const resolveStatusToken = (value, category = 'default') => {
  if (!value) return null;
  const tokens = STATUS_TOKENS[category] || STATUS_TOKENS.default;
  const upper = `${value}`.toUpperCase();
  return tokens[upper] || { label: upper.replace(/_/g, ' ').toLowerCase(), color: 'default' };
};

